module.exports = __webpack_public_path__ + "img/part-1-info-2.b1d7b60c.png";